<template>
  <div class="page-content">
    <page-template ref="addColumn"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="addColumns"
    ></page-template>
    <el-dialog title="余额" :visible.sync="isShow" center width="100px">
      <div class="setCode">
        <div class="button">
          账户余额：
          <el-input v-model="accountMoney" disabled placeholder='暂无数据' maxlength="13">></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          冻结余额：
          <el-input v-model="lockedMoney" disabled placeholder='暂无数据' maxlength="13">></el-input>
        </div>
      </div>
    </el-dialog>
    <!-- 添加UU跑腿 -->
    <el-dialog title="添加UU跑腿" :visible.sync="isAddUUVisible" center width="100px">
      <div class="dialog-body">
        <el-form ref="uuForm" :model='uuFormData' :rules='uuFormRules' label-width='100px' style="display:flex">
          <div style="width:50%">
            <el-form-item label='城市名称' prop='cityName'>
              <el-input placeholder='城市名称如西安市' v-model="uuFormData.cityName" ></el-input>
            </el-form-item>
            <el-form-item label='手机号码' prop='phone'>
              <el-input placeholder='请输入UU跑腿绑定手机号' v-model="uuFormData.phone"></el-input>
            </el-form-item>
          </div>
          <div style="width:50%">
            <el-form-item label='区/县' prop='areaName'>
              <el-input placeholder='区名称如莲湖区' v-model="uuFormData.areaName"></el-input>
            </el-form-item>
            <el-form-item label='短信验证码' prop='code'>
              <el-input placeholder='请输入商户验证码' v-model="uuFormData.code"></el-input>
              <el-button @click="getPhoneCode()">获取验证码</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button type='primary' @click="submitAdd()">提交</el-button>
        <el-button type='default' @click="reset()">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import addForm from "@/components/template/add";

export default {
  components: {
    pageTemplate,
    addForm,
  },
  data() {
    return {
      uuFormData:{
        cityName:'',
        areaName:'',
        phone:'',
        code:'',
      },
      uuFormRules:{
        cityName:[
          {required: true, message: "请输入城市名称", trigger: "blur"},
        ],
        areaName:[],
        phone:[
          {required: true, message: "请输入手机号码", trigger: "blur"},
          {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
        ],
        code:[
          {required: true, message: "请输入短信验证码", trigger: "blur"}
        ],
      },
      isAddUUVisible:false,
      isShow: false,
      accountMoney: '',
      lockedMoney: '',
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "手机号",
            prop: "phone",
            type: "input",
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "添加",
          code: "insert",
          callback: this.isAddUU
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "金额查询",
          code: "amountInquiry",
          callback: this.amountInquiry
        }, {
          label: "充值",
          code: "recharge",
          callback: this.recharge
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: "手机号码",
            prop: "phone",
            width: "120",
            align: "center",
          },
          {
            label: "openId",
            prop: "openId",
            width: "150",
            align: "center",
          },
          {
            label: "商户城市名称",
            prop: "cityName",
            width: "150",
            align: "center",
          },
          {
            label: "区/县",
            prop: "areaName",
            width: "120",
            align: "center",
          },
          {
            label: "注册时间",
            prop: "createDttm",
            width: "120",
            align: "center",
          },
        ],
        url: api.delivery.uuDaMerchant,
      },
      // 添加字段
      addColumns: {
        labelWidth: "120px",
        span: 24,
        columns: [
          {
            label: "城市名称",
            type: "input",
            prop: "cityName",
            placeholder: '城市名称如西安市',
            span: 12,
            rule: [
              {required: true, message: "请输入城市名称", trigger: "blur"},
            ],
          },
          {
            label: "区/县",
            type: "input",
            prop: "areaName",
            placeholder: '区名称如莲湖区',
            span: 12,
          },
          {
            label: "手机号码",
            type: "input",
            prop: "phone",
            placeholder: '请输入UU跑腿绑定手机号',
            span: 12,
            rule: [
              {required: true, message: "请输入手机号码", trigger: "blur"},
              {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
            ],
          },
          {
            label: "短信验证码",
            type: "code",
            prop: "code",
            placeholder: '请输入商户验证码',
            url: api.delivery.uuCode,
            span: 12,
            rule: [
              {required: true, message: "请输入短信验证码", trigger: "blur"},
            ],
          },
        ], // 表单label
        url: api.delivery.uuDaMerchant,
      },
    };
  },
  methods: {
    reset(){
      this.$refs.uuForm.resetFields();
    },
    isAddUU(){
      this.isAddUUVisible=true;
    },
    submitAdd(){
      let url=api.delivery.uuDaMerchant;
      let data={
        cityName:this.uuFormData.cityName,
        areaName:this.uuFormData.areaName,
        phone:this.uuFormData.phone,
        code:this.uuFormData.code
      }
      this.$refs.uuForm.validate((valid)=>{
        if(valid){
          this.$axios.fetchPost(url,data).then((res)=>{
            if(res.code===200){

            }else{
              this.$message.error('提交失败！'+res.errorMsg)
            }
          })
        }else{
          console.log('填写必填字段');
        }
      })
    },
    getPhoneCode(){
      let url=api.delivery.uuCode;
      let data={
        phone:this.uuFormData.phone
      };
      if(!this.uuFormData.phone){
        this.$message({
          message:'请输入手机号',
          type:'warning'
        })
        return;
      }
      this.$axios.fetchPost(url,data).then((res)=>{
        if(res.code===200){

        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
    amountInquiry(data) {
      //console.log(data);
      this.isShow = true;
      this.$axios.fetchPost(api.delivery.uuAccountQuery, {openId: data.openId}).then(res => {
        if (res.code === 200) {
          this.accountMoney = res.data.accountMoney;
          this.lockedMoney = res.data.lockedMoney;
        } else {
          this.$message({message: res.errorMsg, type: "error"});
        }
      });
    },
    recharge(data) {
      //console.log(data);
      this.$axios.fetchPost(api.delivery.uuRecharge, {openId: data.openId}).then(res => {
        if (res.code === 200) {
          let url = res.data;
          let link = document.createElement('a')  // 创建a标签
          link.href = url;
          link.target = "_blank"
          document.body.appendChild(link)
          link.click()
          this.isMoneyShow = false;
        } else {
          this.$message({message: res.errorMsg, type: "error"});
        }
      });
    },
  },
};
</script>
<style scoped>
.setCode{
  text-align: center;
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/page/delivery/uu/Setting.vue